module.exports = __webpack_public_path__ + "static/media/simfoni_logo_1920x1080_transparent_background.58dc75ec.png";